<template>
    <div class="modal-card" style="width: auto;">
        <header class="modal-card-head">
            <p class="modal-card-title">Отправить звонок с авторегистрацией</p>
        </header>

        <section class="modal-card-body">
            <div class="columns">
                <div class="column">
                    <b-field label="Шаблон звонка: ">
                        <b-select placeholder="" icon="duck" v-model="template_id">
                            <option
                                v-for="template in templates"
                                :value="template.id"
                                :key="template.id"
                            >
                                {{ template.name }}
                            </option>
                        </b-select>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Использовать дежурный номер?">
                        <b-switch v-model="from_duty_phone"></b-switch>
                    </b-field>
                </div>
                <div class="column" v-if="!from_duty_phone">
                    <b-field label="Список номеров:">
                        <b-select
                            placeholder="Номер телефона"
                            icon="duck"
                            v-model="outgoing_phone"
                            :loading="isPhonesLoading"
                        >
                            <option v-for="phone in phones" :value="phone.phone" :key="phone.id">
                                {{ phone.phone }}
                            </option>
                        </b-select>
                    </b-field>
                </div>
            </div>
        </section>

        <div class="modal-card-foot is-block">
            <div class="">
                <div class="is-pulled-right">
                    <b-button type="is-default" @click="$parent.close()">Закрыть</b-button>
                    <b-button type="is-primary" @click="send()">Отправить</b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { AxiosClient } from "@/app/shared/services";

export default {
    name: "AutoRegistrationCallTemplate",
    data() {
        return {
            template_id: "",
            from_duty_phone: false,
            outgoing_phone: null,
        };
    },
    created() {
        this.$store.dispatch("GET_TEMPLATES");
        this.$store.dispatch("GET_PHONES");
    },
    computed: {
        templates() {
            return this.$store.getters.TEMPLATES;
        },
        phones() {
            return this.$store.getters.PHONES;
        },
        isPhonesLoading() {
            return this.$store.getters.PHONES_IS_LOADING;
        },
    },
    props: ["utm_source", "file"],
    methods: {
        send() {
            const formData = new FormData();
            formData.append("utm_source", this.utm_source);
            formData.append("file", this.file);
            formData.append("template_id", this.template_id);
            formData.append("outgoing_phone", this.outgoing_phone);
            formData.append("from_duty_phone", this.from_duty_phone);

            AxiosClient.post("/profile/call_with_auto_registration", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
                .then((data) => {
                    this.$toaster.success("Рассылка запущена в фоновом режиме");
                    this.$parent.close();
                })
                .catch((error) => {
                    this.$toaster.error(`Ошибка!${error}`);
                });
        },
    },
};
</script>

<style></style>
